module.exports = __webpack_public_path__ + "img/track-black.3a57e830.svg";